import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useSelector } from 'react-redux';

import { isCategoryUncategorized } from 'entities/Category/lib/isCategoryUncategorized';
import { getLocalCategoriesList } from 'entities/Category/model/selectors/categorySelectors';

import type { SxProps, Theme } from '@mui/material/styles';

interface CategoryLabelProps {
    categoryId: string;
    textSx?: SxProps<Theme>;
}

export const CategoryLabel = ({
    categoryId,
    textSx,
    ...props
}: CategoryLabelProps) => {
    const categories = useSelector(getLocalCategoriesList);

    const color = categories?.[categoryId]?.color;
    const title = categories?.[categoryId]?.title;
    const glCode = categories?.[categoryId]?.glCode;

    if (!categories || !title) {
        return null;
    }

    const showColorDot = Boolean(color) && !isCategoryUncategorized(title);

    const categoryTextSx = {
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        color: (theme: Theme) => alpha(theme.palette.common.black, 0.85),
    };

    return (
        <Box display="flex" gap="4px" alignItems="center" {...props}>
            {showColorDot && (
                <Box
                    height="8px"
                    width="8px"
                    bgcolor={color}
                    borderRadius="50%"
                    flexShrink={0}
                />
            )}
            <Typography
                typography="openSans.body2"
                sx={[categoryTextSx, textSx] as SxProps<Theme>}
            >
                {title}
                {glCode ? ` | ${glCode}` : ''}
            </Typography>
        </Box>
    );
};
